import { useImperativeHandle, useState } from 'react';
import { DragPreview } from '../../../dnd/view/DragPreview';
import { BadgeButton } from '../../BadgeButton';
import cn from '../Table.css.json';
import '../Table.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DraggableRow = props => {
  const dragCount = props.numberOfRows ?? -1;
  const [internalChildren, setInternalChildren] = useState(props.children);
  useImperativeHandle(props.dragRowRef, () => ({
    updateContent: children => {
      setInternalChildren(children);
    }
  }), []);
  if (!internalChildren) return null;
  const multipleLayers = dragCount > 1;
  return /*#__PURE__*/_jsxs(DragPreview, {
    style: props.style,
    className: cn.ghost,
    children: [multipleLayers ? /*#__PURE__*/_jsx("div", {
      className: cn.ghostBottom
    }) : null, /*#__PURE__*/_jsx("div", {
      className: cn.ghostTop,
      children: internalChildren
    }), multipleLayers ? /*#__PURE__*/_jsx(BadgeButton, {
      className: cn.rowCount,
      value: dragCount,
      badgeDesign: "square"
    }) : null]
  });
};
//# sourceMappingURL=DraggableRow.js.map